import React, { useEffect, useState, useCallback } from 'react';
import { Edit, Delete, Add, ArrowBack, Search } from "@mui/icons-material";
import api from '../../services/api';
import styles from '../../assets/styles/LayoutShared.module.css';
import EspecieForm from './EspecieForm';

const EspeciesList = () => {
  const [especies, setEspecies] = useState<any[]>([]);
  const [carregando, setCarregando] = useState(true);
  const [search, setSearch] = useState('');
  const [tempSearch, setTempSearch] = useState('');
  const [formOpen, setFormOpen] = useState(false);
  const [uidEditando, setUidEditando] = useState<string | undefined>(undefined);

  const fetchEspecies = useCallback((searchTerm: string) => {
    setCarregando(true);
    const params = new URLSearchParams();
    if (searchTerm) params.set('search', searchTerm);
    api.get(`/pesca/especies?${params.toString()}`)
      .then((res) => setEspecies(res.data.data))
      .finally(() => setCarregando(false));
  }, []);

  useEffect(() => {
    const handler = setTimeout(() => setSearch(tempSearch), 500);
    return () => clearTimeout(handler);
  }, [tempSearch]);

  useEffect(() => { fetchEspecies(search); }, [search, fetchEspecies]);

  const handleNovo = () => {
    setUidEditando(undefined);
    setFormOpen(true);
  };

  const handleEditar = (especie: any) => {
    setUidEditando(especie.uid_pesca_especie);
    setFormOpen(true);
  };

  const handleInativar = async (especie: any) => {
    if (!window.confirm(`Inativar a espécie "${especie.nome_popular}"? Capturas já registradas continuam íntegras.`)) return;
    try {
      await api.delete(`/pesca/especies/${especie.uid_pesca_especie}`);
      fetchEspecies(search);
    } catch (err: any) {
      alert(err?.response?.data?.message || 'Erro ao inativar espécie.');
    }
  };

  const handleSalvo = () => {
    setFormOpen(false);
    fetchEspecies(search);
  };

  return (
    <div className={styles.container}>
      <div className={styles.headerTitle}>
        <h1 className={styles.greenTitle}>Espécies Cadastradas</h1>

        <div style={{ position: 'relative', flex: 1, maxWidth: '400px', margin: '0 20px' }}>
          <Search style={{ position: 'absolute', left: '10px', top: '10px', color: '#888' }} />
          <input
            type="text"
            placeholder="Pesquisar por nome popular ou científico..."
            value={tempSearch}
            onChange={(e) => setTempSearch(e.target.value)}
            style={{ width: '100%', padding: '10px 10px 10px 40px', borderRadius: '20px', border: '1px solid #ddd', outline: 'none' }}
          />
        </div>

        <div className={styles.actionsHeader}>
          <p style={{ alignSelf: 'center', fontSize: '0.9rem', color: '#666', marginRight: '10px' }}>
            Qtd: <span style={{ fontWeight: 'bold', color: 'var(--green-700)' }}>{especies.length}</span>
          </p>
          <button className={styles.blueBtn} onClick={handleNovo} title="Nova Espécie">
            <Add />
          </button>
          <button className={styles.blueBtn} onClick={() => window.history.back()} title="Voltar">
            <ArrowBack />
          </button>
        </div>
      </div>

      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Nome Popular</th>
              <th>Nome Científico</th>
              <th>Aliases / Nomes Regionais</th>
              <th>Projeto(s)</th>
              <th style={{ textAlign: 'center' }}>Ações</th>
            </tr>
          </thead>
          <tbody>
            {carregando ? (
              <tr><td colSpan={5} style={{ textAlign: 'center', padding: '20px', color: '#999' }}>Carregando...</td></tr>
            ) : especies.length === 0 ? (
              <tr><td colSpan={5} style={{ textAlign: 'center', padding: '20px', color: '#999' }}>Nenhuma espécie cadastrada.</td></tr>
            ) : (
              especies.map((e) => (
                <tr key={e.uid_pesca_especie} style={e.syn_canmom ? { opacity: 0.5 } : undefined}>
                  <td>
                    {e.nome_popular}
                    {e.syn_canmom && <span style={inactiveBadgeStyle}>Inativa</span>}
                  </td>
                  <td><i style={{ color: '#666' }}>{e.nome_cientifico || '-'}</i></td>
                  <td>{typeof e.qtd_nomes === 'number' ? e.qtd_nomes : '-'}</td>
                  <td>{typeof e.qtd_projetos === 'number' ? e.qtd_projetos : '-'}</td>
                  <td>
                    <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                      <Edit fontSize="small" style={{ color: '#03c9fe', cursor: 'pointer' }} onClick={() => handleEditar(e)} />
                      {!e.syn_canmom && (
                        <Delete fontSize="small" style={{ color: '#f75a68', cursor: 'pointer' }} onClick={() => handleInativar(e)} />
                      )}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {formOpen && (
        <EspecieForm
          uidEditando={uidEditando}
          onClose={() => setFormOpen(false)}
          onSaved={handleSalvo}
        />
      )}
    </div>
  );
};

const inactiveBadgeStyle: React.CSSProperties = {
  marginLeft: '8px', fontSize: '0.68rem', fontWeight: 700, padding: '2px 8px',
  borderRadius: '10px', background: '#f5f5f5', color: '#999', textTransform: 'uppercase',
};

export default EspeciesList;
